module.exports = __webpack_public_path__ + "static/media/ic_categories_pet.88fa290e.svg";